import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import DurationCustomComponent from './DurationCustomComponent';
import DurationPredefinedComponent from './DurationPredefinedComponent';

import './DurationField.css';

const DurationField = ({ name, predefinedValues, onlyParts, onDurationChange, placeholder, noGoBack, ..._rest }) => {
    const [customFieldIsVisible, setCustomFieldIsVisible] = useState(!predefinedValues);
    const [durationValue, setDurationValue] = useState(null);

    useEffect(() => {
        if (durationValue && !predefinedValues?.map(v => v.value).includes(durationValue))
            setCustomFieldIsVisible(true);
    }, [durationValue, predefinedValues]);

    return (
        <div className="DurationField">

            {customFieldIsVisible && (
                <Field
                    className="form-control"
                    name={ name }
                    component={ DurationCustomComponent }
                    onDurationChange={onDurationChange}
                    onlyParts={onlyParts}
                    noGoBack={!!noGoBack}
                    setCustomFieldIsVisible={setCustomFieldIsVisible}
                />
            )}

            {!customFieldIsVisible && (
                <Field
                    className="form-control"
                    name={ name }
                    component={ DurationPredefinedComponent }
                    predefinedValues={predefinedValues}
                    onDurationChange={onDurationChange}
                    setDurationValue={setDurationValue}
                    setCustomFieldIsVisible={setCustomFieldIsVisible}
                />
            )}
        </div>
    );
}

export default DurationField;
